import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const SpecialEventInfo = styled.div<{ $isEventColumn?: boolean; $isSeriesLink?: boolean }>`
    ${BaseStyle.Mixins.fontStyles.ui['12m']};
    color: ${({ theme, $isSeriesLink }) => ($isSeriesLink ? theme.Utility.cta : theme.Text.secondary)};
    cursor: ${({ $isSeriesLink }) => ($isSeriesLink ? 'pointer' : 'default')};
    display: ${({ $isEventColumn }) => ($isEventColumn ? 'flex' : 'none')};
    align-items: center;
    justify-content: center;
    text-align: center;
    margin-right: -15px;

    ${BaseStyle.Mixins.screenSizes.large} {
        display: ${({ $isEventColumn }) => ($isEventColumn ? 'none' : 'flex')};
        margin-top: 4px;
    }
`;
